import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "../contexts/I18nContext";

// Redirect to new unified Budget page with confronto view
export default function BudgetConfrontoPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { tenant } = useParams();
  
  useEffect(() => {
    // Redirect to budget page - the user can switch to confronto view there
    navigate(`/${tenant}/budget`, { replace: true });
  }, [navigate, tenant]);
  
  return null;
}
